import React, { useEffect, useState } from "react";
import { Field, Formik, Form } from "formik";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box, FormGroup, makeStyles, Typography } from "@material-ui/core";
import AppColor from "utilities/AppColor";
import AppButton from "components/CustomButtons/AppButton";
// import { Link } from "react-router-dom";
import AppCheckbox from "components/Input/AppCheckbox";
import AppConfig from "config/AppConfig";
import InputUpload from "components/Input/InputUpload";
import * as Yup from "yup";

const { APPROVAL_STATUS } = AppConfig;
const AgreementForm = (props) => {
  const {
    onSubmit,
    isSubmitting,
    display,
    changeProgressStatus,
    companyDetail = {},
    disabled,
    hideLeftControl
  } = props;

  const { t } = useTranslation();


  const [initForm, setInitForm] = useState({
    haveAgreement: false,
    agreementFile: null
  });

  const { company = {} } = companyDetail;
  const {
    id: companyId,
    approvalStatus = ''
  } = company;

  const styles = makeStyles(() => ({
    title: {
      display: 'flex',
      margin: '2rem 0 1rem 0',
      '& h5': {
        color: AppColor.mainColor,
      }
    },
    control: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: hideLeftControl ? 'flex-end' : 'space-between',
      '& a': {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: AppColor.pink
      }
    },
    textDownload: {
      cursor: 'pointer',
      marginBottom: '5rem',
      '& span': {
        color: AppColor.blue,
        textDecoration: 'underline',
        marginRight: '0.5rem'
      }
    }
  }));
  const classes = styles();

  const {
    company: {
      agreementFile: agreementFile,
      agreementFileAws3Link: agreementFileAws3Link
    } = {}
  } = companyDetail;

  useEffect(() => {
    if (companyDetail && Object.keys(companyDetail).length > 0) {
      let isApproval = false;
      if (approvalStatus !== APPROVAL_STATUS.PENDING) {
        isApproval = true;
      }
      const initial = {
        agreementFile: agreementFile === '' ? null : agreementFile,
        agreementFileAws3Link: agreementFileAws3Link === '' ? null : agreementFileAws3Link,
        haveAgreement: isApproval
      };

      validationSchema
        .isValid(initial)
        .then((valid) => {
          setTimeout(() => {
            changeProgressStatus(3, valid);
          }, 500);
        });
      setInitForm(initial);
    }
  }, [companyDetail]);

  const handleSubmitForm = (data) => {
    const params = {
      companyId,
      ...data
    };
    onSubmit(params);
  };

  const validationSchema = Yup.object().shape({
    agreementFile: Yup.mixed().required("validation.requiredFile")
  });

  return (
    <Formik
      enableReinitialize={true}
      onSubmit={handleSubmitForm}
      initialValues={initForm}
      validationSchema={validationSchema}
    >
      {({ values }) => {
        return (
          <Form className={`${!display && 'hidden'}`}>
            <Box className={classes.title}>
              <Typography variant="h5">
                {t("title.agreement")}
              </Typography>
            </Box>
            <Field
              component={AppCheckbox}
              label={t("text.acceptAgreement")}
              id="haveAgreement"
              name="haveAgreement"
              disabled={disabled}
            />
            {/* <Box styles={{
              fontWeight: 400,
              fontSize: '1rem',
              lineHeight: 1.5,
              color: 'rgb(0, 0, 0)'
            }}>
              <span>
                {`By providing a support worker with CareAid, you enter into our Employment 
                  Agreement for Support Workers.

                  On behalf of CareAid Pty Ltd (ACN 600 120 787) (CareAid), I am very 
                  pleased to confirm our offer of employment to you.

                  The terms and conditions of the offer of employment are set out below 
                  (Agreement). Defined terms are set out in paragraph 9 below. You 
                  agree that any Bookings to be performed on or after the 
                  Commencement Date will be governed by this Agreement.`}
              </span>
            </Box> */}
            <a href="/documents/Service_Agreement.pdf" download="Service_Agreement.pdf">
              <Box className={classes.textDownload}>
                <span>{t('label.downloadAgreement')}</span>
                <i className="fas fa-download"></i>
              </Box>
            </a>
            {/* {typeof values.agreementFile === 'string' && values.agreementFile && (
                <Box display="flex" justifyContent="flex-end">
                  <a
                      href={values.agreementFileAws3Link}
                      download={values.agreementFile}
                  >
                    <Box className={classes.textDownload} style={{marginBottom: 0}}>
                      <span>{t('label.download')}</span>
                      <i className="fas fa-download"></i>
                    </Box>
                  </a>
                </Box>
            )} */}
            <Field
              component={InputUpload}
              accept="application/pdf"
              name="agreementFile"
              disabled={disabled}
              showIconUpload={true}
              showIconDownload={typeof values.agreementFile === 'string' && values.agreementFile}
              renderIconDownload={() => (
                <a href={values.agreementFileAws3Link} download={values.agreementFile}>
                  <Box className={classes.textDownload} style={{ marginBottom: 0 }}>
                    <span>{t('label.download')}</span>
                    <i className="fas fa-download"></i>
                  </Box>
                </a>
              )}
            />
            {
              !disabled && (
                <FormGroup className={classes.control}>
                  <AppButton
                    label={`${t("button.submit")}`}
                    rounder
                    type="submit"
                    isLoading={isSubmitting}
                    disabled={isSubmitting || !values.haveAgreement}
                  />
                </FormGroup>
              )
            }
          </Form>
        );
      }}
    </Formik>
  );
};

AgreementForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  display: PropTypes.bool,
  disabled: PropTypes.bool,
  hideLeftControl: PropTypes.bool,
  companyDetail: PropTypes.object,
  changeProgressStatus: PropTypes.func
};

export default AgreementForm;
